import { GameContext } from '../../../../contexts/GameContext';
import { ZdarKidsGameStepConfiguration } from '../../../../configuration/games/zdar-kids-game/zdarKidsGameContentConfiguration';
import Button from '../../../common/buttons/Button';
import ContinueButton from '../../../common/buttons/ContinueButton';
import React, { ReactNode, useCallback, useContext, useState } from 'react';
import ZdarFairyTaleCharactersCarousel from './ZdarFairyTaleCharactersCarousel';
import image1 from '../../../../assets/images/games/zdar-kids-game/cartoons/1.webp';
import image2 from '../../../../assets/images/games/zdar-kids-game/cartoons/2.webp';
import image3 from '../../../../assets/images/games/zdar-kids-game/cartoons/3.webp';
import image4 from '../../../../assets/images/games/zdar-kids-game/cartoons/4.webp';
import image5 from '../../../../assets/images/games/zdar-kids-game/cartoons/5.webp';
import image6 from '../../../../assets/images/games/zdar-kids-game/cartoons/6.webp';

type TImage = {
    url: any;
    id: number;
    slide: number;
};

type Props = {
    onSuccess: () => void;
};
export default function ZdarFairyTaleCharactersCipher({ onSuccess }: Props) {
    const { stepContent } = useContext(GameContext);

    const { continueButtonText } = stepContent as ZdarKidsGameStepConfiguration;
    const [selectedSlide, setSelectedSlide] = useState(0);
    const [solved, setSolved] = useState<TImage[]>([]);
    const [images] = useState<TImage[]>([
        { url: image1, id: 1, slide: 0 },
        { url: image2, id: 2, slide: 1 },
        { url: image3, id: 3, slide: 2 },
        { url: image4, id: 4, slide: 3 },
        { url: image5, id: 5, slide: 4 },
        { url: image6, id: 6, slide: 5 },
    ]);
    const [answers] = useState([
        { name: 'Blesk', id: 1000, slide: 0 },
        { name: 'Hněďák', id: 1000, slide: 0 },
        { name: 'Burák', id: 1, slide: 0 },
        { name: 'Červená karkulka', id: 2, slide: 1 },
        { name: 'Červená Martinka', id: 2000, slide: 1 },
        { name: 'Růžová karkulka', id: 2000, slide: 1 },
        { name: 'Rumcajs', id: 3000, slide: 2 },
        { name: 'Shrek', id: 3, slide: 2 },
        { name: 'Rákosníček', id: 3000, slide: 2 },
        { name: 'Šmoulinka', id: 4, slide: 3 },
        { name: 'Fifinka', id: 4000, slide: 3 },
        { name: 'Zvonilka', id: 4000, slide: 3 },
        { name: 'Včelka Mája', id: 5, slide: 4 },
        { name: 'Včelka Martinka', id: 5000, slide: 4 },
        { name: 'Včelka Anička', id: 5000, slide: 4 },
        { name: 'Víla Sněhurka', id: 6000, slide: 5 },
        { name: 'Víla Zlatovláska', id: 6000, slide: 5 },
        { name: 'Víla Amálka', id: 6, slide: 5 },
    ]);

    const onCompleteSlide = useCallback((idx: number, _item: ReactNode) => {
        setSelectedSlide(idx);
    }, []);

    const onClick = (n: number) => {
        if (n === images[selectedSlide].id && !solved.find((s) => s.id === n)) {
            const newSolved = [];
            newSolved.push(...solved);
            newSolved.push(images[selectedSlide]);
            setSolved(newSolved);
        }
    };

    const isSlideSolved = (i: number) => {
        return solved.filter((s) => s.slide === i).length > 0;
    };
    return (
        <React.Fragment>
            <div className="zdar-kids-cipher__fairytales">
                <div className="zdar-kids-cipher__fairytales__text">
                    Správně {solved.length}/{images.length}
                </div>
                <ZdarFairyTaleCharactersCarousel onCompleteSlide={onCompleteSlide} images={images} solved={solved} />
                {answers && answers.length > 0 && (
                    <div className="zdar-kids-cipher__fairytales__names-wrapper">
                        {answers
                            ?.filter((s) => s.slide === selectedSlide)
                            ?.filter((s) => !isSlideSolved(s.slide))
                            .map((f, i) => {
                                return (
                                    <Button
                                        onClick={() => onClick(f.id)}
                                        key={i}
                                        className="zdar-kids-cipher__fairytales__name secondary-button"
                                    >
                                        {f.name}
                                    </Button>
                                );
                            })}
                        {isSlideSolved(selectedSlide) && (
                            <div className="zdar-kids-cipher__fairytales__solved-text">postavu jste už uhodli</div>
                        )}
                    </div>
                )}
                {solved.length === images.length && (
                    <>
                        <div className="zdar-kids-cipher__fairytales__solved">Máte to všechno správně!</div>
                        {continueButtonText && <ContinueButton text={continueButtonText} onClick={onSuccess} />}
                    </>
                )}
            </div>
        </React.Fragment>
    );
}
